// import { useLoader } from "@react-three/fiber";
import { EffectComposer, Bloom } from "@react-three/postprocessing";
// import { LUTCubeLoader } from "postprocessing";

export default function Effects() {
  const enabled = false;
  return (
    enabled && (
      <EffectComposer>
        {/* <SSR {...props} /> */}
        <Bloom
          luminanceThreshold={0.99}
          mipmapBlur
          radius={0.34}
          luminanceSmoothing={1}
          intensity={0.15}
        />
      </EffectComposer>
    )
  );
}
